<template>
    <section class="video-section">
        <div class="container">
            <!-- Video Player -->
            <div class="video-wrapper">
                <video
                    ref="interviewVideo"
                    class="interview-video"
                    controls
                    preload="metadata"
                    poster="/images/titleImage.jpg"
                    @loadedmetadata="onVideoLoaded"
                >
                    <source src="/images/Interview_Sylvia_Braun_Final_1080p_1.mp4" type="video/mp4">
                    Ihr Browser unterstützt das Video-Tag nicht.
                </video>
            </div>

            <!-- Chapter Accordion -->
            <div class="chapter-accordion">
                    <div class="accordion-header" @click="toggleAccordion">
                        <h3 class="accordion-title">Kapitel</h3>
                        <span class="accordion-icon" :class="{ 'is-open': isAccordionOpen }">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                <path d="M8 11L3 6h10l-5 5z"/>
                            </svg>
                        </span>
                    </div>

                    <div class="accordion-content" :class="{ 'is-open': isAccordionOpen }">
                        <ul class="chapter-list">
                            <li
                                v-for="(chapter, index) in chapters"
                                :key="index"
                                class="chapter-item"
                                @click="seekToChapter(chapter.time)"
                            >
                                <span class="chapter-time">{{ chapter.timeString }}</span>
                                <span class="chapter-title">{{ chapter.title }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'VideoSection',
    data() {
        return {
            isAccordionOpen: false,
            chapters: [
                { timeString: '00:00', time: 0, title: 'Mein Werdegang' },
                { timeString: '01:13', time: 73, title: 'Wie ist es Ihnen gelungen, Beruf und Familie miteinander zu vereinbaren?' },
                { timeString: '01:54', time: 114, title: 'Wie sind Sie ursprünglich zur Politik gekommen?' },
                { timeString: '03:52', time: 232, title: 'Welches Hauptthema wollen Sie als erstes angehen und warum ist Ihnen das wichtig?' },
                { timeString: '05:47', time: 347, title: 'Welche Erfahrungen aus Ihrer beruflichen Laufbahn waren besonders hilfreich für Ihre Arbeit in der Politik?' },
                { timeString: '06:58', time: 418, title: 'Welche Herausforderungen haben Sie in Ihrer Anfangszeit als Bürgermeisterin erlebt?' },
                { timeString: '07:49', time: 469, title: 'Wie hat sich die Stadt in den letzten fünf Jahren verändert?' },
                { timeString: '08:49', time: 529, title: 'Welche Projekte haben Ihrer Meinung nach entscheidend dazu beigetragen, dass sich die Stadt in den letzten fünf Jahren so entwickelt hat?' },
                { timeString: '09:44', time: 584, title: 'Wie haben Sie die Veränderung im Stadtparlament in den letzten Jahren erlebt?' },
                { timeString: '11:43', time: 703, title: 'Aus welchen Projekten konnten Sie und die Stadt besonders viel lernen?' },
                { timeString: '13:51', time: 831, title: 'Wie haben Sie sich in den letzten fünf Jahren als Bürgermeisterin persönlich verändert?' },
                { timeString: '15:07', time: 907, title: 'Welche persönlichen oder charakterlichen Qualitäten haben sich in dieser Zeit besonders entwickelt oder gefestigt?' },
                { timeString: '16:07', time: 967, title: 'Welche Erfahrungen und aus Ihrer bisherigen Amtszeit werden Ihnen in einer möglichen nächsten Amtszeit besonders helfen?' },
                { timeString: '17:36', time: 1056, title: 'Welche Projekte würden Sie in einer nächsten Amtszeit als erstes weiter vorantreiben?' },
                { timeString: '18:51', time: 1131, title: 'Was möchten Sie den Bürgerinnen und Bürgern zum Abschluss mit auf den Weg geben?' },
                { timeString: '19:19', time: 1159, title: 'Was war der ergreifendste oder bewegendste Moment in Ihrer bisherigen Amtszeit?' }
            ]
        }
    },
    methods: {
        toggleAccordion() {
            this.isAccordionOpen = !this.isAccordionOpen
        },
        seekToChapter(timeInSeconds) {
            const video = this.$refs.interviewVideo
            if (video) {
                video.currentTime = timeInSeconds
                video.play()

                // Scroll to the video
                video.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        },
        onVideoLoaded() {
            // Video metadata loaded
        }
    }
}
</script>
